<cmps-dialog class="cmps-cdk-p-0">
    <cmps-dialog-body>
        <div class="cmps-cdk-d-flex cmps-cdk-px-1 cmps-cdk-py-0dot75">
            <div
                class="cmps-cdk-d-flex cmps-cdk-font-bold cmps-cdk-font-size-16p cmps-cdk-flex-grow-1 cmps-cdk-align-items-center"
            >
                Schedule
            </div>
        </div>
        <div
            class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
        ></div>
        <div
            class="cmps-cdk-w-512px cmps-cdk-d-flex cmps-cdk-flex-column"
        ></div>
        <div
            class="cmps-cdk-border-b-width-1p cmps-cdk-border-b-solid cmps-cdk-border-b-color-grey-100"
        ></div>
        <div
            class="cmps-cdk-cg-0dot75 cmps-cdk-d-flex cmps-cdk-justify-content-flex-end cmps-cdk-p-1"
        >
            <div>
                <button
                    type="button"
                    class="cmps-cdk-align-items-center cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4px cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-color-blue-100 not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 focus:not:focus-visible:cmps-cdk-outline-none"
                    (click)="_dialogRef.close()"
                >
                    <span class="cmps-cdk-line-clamp-1">Cancel</span>
                </button>
            </div>
            <div>
                <button
                    type="button"
                    class="cmps-cdk-align-items-center cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white not:disabled:cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-font-bold cmps-cdk-justify-content-center cmps-cdk-min-h-34p cmps-cdk-px-1 disabled:cmps-cdk-opacity-0dot5 focus:not:focus-visible:cmps-cdk-outline-none"
                    [disabled]="_state.creatingJob"
                    (click)="_onScheduleClick()"
                >
                    <span class="cmps-cdk-line-clamp-1">Schedule</span>
                </button>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
